/* tslint:disable */
/* eslint-disable */
/**
 * SmartAI BMAW
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GlossaryFileSupport } from './GlossaryFileSupport';
import {
    GlossaryFileSupportFromJSON,
    GlossaryFileSupportFromJSONTyped,
    GlossaryFileSupportToJSON,
    GlossaryFileSupportToJSONTyped,
} from './GlossaryFileSupport';

/**
 * 
 * @export
 * @interface GlossaryFileSupportResponse
 */
export interface GlossaryFileSupportResponse {
    /**
     * 
     * @type {Array<GlossaryFileSupport>}
     * @memberof GlossaryFileSupportResponse
     */
    glossaryFileSupports: Array<GlossaryFileSupport>;
}

/**
 * Check if a given object implements the GlossaryFileSupportResponse interface.
 */
export function instanceOfGlossaryFileSupportResponse(value: object): value is GlossaryFileSupportResponse {
    if (!('glossaryFileSupports' in value) || value['glossaryFileSupports'] === undefined) return false;
    return true;
}

export function GlossaryFileSupportResponseFromJSON(json: any): GlossaryFileSupportResponse {
    return GlossaryFileSupportResponseFromJSONTyped(json, false);
}

export function GlossaryFileSupportResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GlossaryFileSupportResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'glossaryFileSupports': ((json['glossaryFileSupports'] as Array<any>).map(GlossaryFileSupportFromJSON)),
    };
}

export function GlossaryFileSupportResponseToJSON(json: any): GlossaryFileSupportResponse {
    return GlossaryFileSupportResponseToJSONTyped(json, false);
}

export function GlossaryFileSupportResponseToJSONTyped(value?: GlossaryFileSupportResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'glossaryFileSupports': ((value['glossaryFileSupports'] as Array<any>).map(GlossaryFileSupportToJSON)),
    };
}

